import { reactive, ref } from 'vue'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import { usePoliticalActions } from './usePoliticalActions'
import axios from '@/axios'

// MemoryOffice.vue - rejectHeadersData 内で作成
const setRejectHeaders = []
const rejectHeaders = reactive(setRejectHeaders)

const isRejectBtnEnabled = ref(false)
const rejectedAttrs = reactive([])
// const { makeStayingText } = MemoryPreview()

export const useMemoryReject = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const resetMemoryRejectedItems = () => {
    while (rejectedAttrs.length > 0) {
      rejectedAttrs.pop()
    }
    rejectHeaders.forEach(x => (x.comment = ''))
  }

  const toUnderscoreCase = str => {
    return str
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase()
  }

  const toSnake = () => {
    for (let i = 0; i < rejectedAttrs.length; i++) {
      Object.keys(rejectedAttrs[i]).forEach(function(key) {
        rejectedAttrs[i][key] = toUnderscoreCase(rejectedAttrs[i][key])
        // console.log(toUnderscoreCase(rejectedAttrs[i][key]))
        // rejectedAttrs[i][key] = 'aaa'
      })
    }
  }

  let data = reactive({})
  const submitReject = async (id, type) => {
    const { getActivitiesAfterResponse } = usePoliticalActions()
    console.log(rejectedAttrs.values)
    try {
      toggleShowLoader(true)
      toSnake()
      data = {
        document_id: id,
        document_type: type,
        sent_back_items: rejectedAttrs,
      }
      let res = null
      res = await axios.post(`/actions/reject`, data)
      await getActivitiesAfterResponse(res)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    setRejectHeaders,
    rejectHeaders,
    rejectedAttrs,
    isRejectBtnEnabled,
    resetMemoryRejectedItems,
    submitReject,
  }
}
